import { AgreementIsActive } from '../../../../types/Agreements.types';

export const statusColors = {
  [AgreementIsActive.active]: 'var(--color-light-greyish-lime-green)',
  [AgreementIsActive.pending]: 'var(--color-mid-greyish-blue)',
  [AgreementIsActive.expired]: 'var(--color-light-grey-red)',
  [AgreementIsActive.inactive]: 'var(--color-greyish-blue)',
};
